import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

class UserRolesService extends CustomEventDispatcher {

  constructor() {
    super();
  }

  async getAll() {
    try {
      const response = await api.get('/api/user-roles');
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }

  async checkRole(role) {
    try {
      const response = await api.get(`/api/user-roles/check?role=${role}`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      return { success: false, hasRole: false };
    }
  }

  async addRole(email, role) {
    try {
      const response = await api.post('/api/user-roles', { email, role });
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }

  async removeRole(id) {
    try {
      const response = await api.delete(`/api/user-roles/${id}`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }
}

export default UserRolesService;
